import React from 'react';
import { SEO } from '../components/SEO';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <SEO
        title="FAQ - NIT Solutions | IT Services Calgary"
        description="Frequently asked questions about NIT Solutions' IT services in Calgary. Learn about our comprehensive IT solutions, support services, and business technology expertise."
        keywords="IT services FAQ, Calgary IT support, NIT Solutions FAQ, business IT solutions, IT security questions"
        path="/faq"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Frequently Asked Questions</h1>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">{faq.question}</h2>
              <div className="text-gray-600 space-y-4">
                {typeof faq.answer === 'string' ? (
                  <p>{faq.answer}</p>
                ) : (
                  <div>
                    <p>{faq.answer.text}</p>
                    {faq.answer.list && (
                      <ul className="list-disc list-inside mt-2 ml-4">
                        {faq.answer.list.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const faqs = [
  {
    question: "What is NIT Solutions?",
    answer: "NIT Solutions is a comprehensive IT service provider based in Calgary. We specialise in supporting small and medium-sized businesses (SMBs) by offering tailored technology solutions."
  },
  {
    question: "What services does NIT Solutions offer?",
    answer: {
      text: "We offer a range of IT services crucial for modern businesses, including:",
      list: [
        "IT Security: Enterprise-grade solutions to protect your business from cyber threats.",
        "Cloud Solutions: Seamless integration and reliable backup services for your data and applications.",
        "24/7 Support: Round-the-clock technical support to ensure smooth IT operations.",
        "Print Management: Cost-effective and efficient print solutions tailored to your needs."
      ]
    }
  },
  {
    question: "Why should I choose NIT Solutions as my IT partner?",
    answer: {
      text: "We believe in building strong partnerships with our clients, and we offer several key advantages:",
      list: [
        "Expertise: Over 15 years of experience serving Calgary businesses across diverse industries.",
        "Reliability: We guarantee 99.9% uptime for your critical systems through proactive monitoring.",
        "Customer Focus: Our dedicated support team provides rapid response times and personalised assistance."
      ]
    }
  },
  {
    question: "What is the benefit of 24/7 IT Support?",
    answer: "Our 24/7 support service ensures that you have access to technical assistance whenever you need it. This means that critical issues can be addressed promptly, minimising downtime and ensuring business continuity."
  },
  {
    question: "How can I improve my business's IT security?",
    answer: "NIT Solutions provides robust security solutions tailored to your business needs. This includes threat detection, data encryption, vulnerability assessments, and security awareness training to prevent cyberattacks and protect your sensitive information."
  },
  {
    question: "What are the advantages of cloud solutions for my business?",
    answer: "Cloud solutions offer flexibility, scalability, and cost savings. We can help you seamlessly migrate to the cloud, manage your cloud infrastructure, and leverage cloud-based applications to streamline your operations."
  },
  {
    question: "How can print management services benefit my business?",
    answer: "Efficient print management can significantly reduce costs and improve workflow. We analyse your printing needs and implement solutions to optimise printer usage, manage supplies, and reduce waste, leading to a more efficient and sustainable workplace."
  },
  {
    question: "How can I get started with NIT Solutions?",
    answer: "We offer a free consultation to discuss your specific IT needs and explore how we can help you achieve your business goals. Contact us today to schedule your consultation."
  }
];

export default FAQ;